import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AttachFileIcon from '@mui/icons-material/AttachFile';

import { getAPI } from '../util/APIUtils';

import { downloadData } from 'aws-amplify/storage';

import { DownloadDocument } from './MainMenu';

type Props = {
  open: boolean;
  idid: string;
  downloadDocument: DownloadDocument;
  handleClose: () => void;
  handleCreate: (type: number) => void;
};

export const DocumentCreateDialog: React.FC<Props> = (props) => {

  const handleClick = (type: number) => {
    props.handleCreate(type);
  };

  const downloadContents = (title: string, path: string) => {
    return (
      <>
        <span style={{ marginLeft: '10px' }}>
          {title}
          <Tooltip title="ダウンロード">
            <IconButton aria-label="remove" color='secondary' onClick={() => handleDownload(path)}>
              <AttachFileIcon color='secondary' fontSize="medium" />
            </IconButton>
          </Tooltip>
        </span>
        <br />
      </>
    );
  };

  const handleDownload = async (path: string) => {
    if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
      downloadFormLGWAN(path);
    } else {
      downloadForm(path);
    }
  };

  const downloadFormLGWAN = async (path: string) => {
    const apiurl = `/tempfile?path=private/${props.idid}/${path}`;
    const json = await getAPI(apiurl);
    const realdownloadurl = (process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT && process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT) ? json.downloadUrl.replace(process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT, process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT) : json.downloadUrl;

    const file = await fetch(realdownloadurl);
    const blob = await file.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const filename = path.split('/').pop();
    link.setAttribute('download', filename ? filename : 'noname');
    document.body.appendChild(link);
    link.click();
  };

  const downloadForm = async (path: string) => {
    //const file = await Storage.get(path, { level: 'private' });
    const downloadTask = await downloadData({
      path: `private/${props.idid}/${path}`,
    });
    const { body } = await downloadTask.result;
    const blob = new Blob([await body.blob()]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    //const filename = path.split('/').pop();
    link.setAttribute('download', path);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <Dialog
      open={props.open}
      keepMounted
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{"資料を出力する"}</DialogTitle>
      <DialogContent>
        <Button variant="outlined" color="secondary" onClick={() => handleClick(0)} sx={{
          margin: (theme) => theme.spacing(1),
        }}>全文</Button>
        <br />
        {props.downloadDocument.allact ? downloadContents('全文', props.downloadDocument.allact) : ''}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
};
